// Display formatting for the Ambassador Calculator and its presentation.
// Money is USD (Request's platform revenue is booked in dollars), in whole
// dollars on screen; the math underneath keeps full precision. A blank value
// shows as "—".
type N = number | null;

const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const usd = (n: N): string => (n === null ? "—" : USD.format(n));

// Three decimals (0.570%). A share too small for that still reads as above zero.
export function pct(n: N): string {
  if (n === null) return "—";
  if (n > 0 && n < 0.0005) return "<0.001%";
  return `${n.toFixed(3)}%`;
}

export const count = (n: N): string =>
  n === null ? "—" : n.toLocaleString("en-US", { maximumFractionDigits: 2 });

export const times = (n: N): string => (n === null ? "—" : `${count(n)}×`);

export const yearsLabel = (start: number, end: number): string =>
  start === end ? `Year ${start}` : `Years ${start}–${end}`;

export const plural = (n: number, one: string, many = `${one}s`): string => `${count(n)} ${n === 1 ? one : many}`;

// "@djlucky" however it was typed; "" when there is none.
export function handle(h: string): string {
  const bare = h.trim().replace(/^@+/, "");
  return bare ? `@${bare}` : "";
}

function when(iso: string | null, opts: Intl.DateTimeFormatOptions): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString("en-US", opts);
}
export const date = (iso: string | null) => when(iso, { month: "short", day: "numeric", year: "numeric" });
export const dateTime = (iso: string | null) =>
  when(iso, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
